(function($) {

    $(document).ready(function() {
        if ($(".intro-block .description-wrap article").length > 0) {
            $(".intro-block").addClass("article-detail");
        }
        if ($(".article-detail.news-detail").length > 0) {
            $("header.library").addClass("news-detail");
            $(".article-detail.news-detail").addClass("small-font");
        }
        if ($(".article-detail.event-detail").length > 0) {
            $("header.library").addClass("event-detail");
            $(".article-detail.news-wrap.event-detail").addClass("small-font");
        }
        if ($(".intro-block .description-wrap figure").length > 0) {
            $(".intro-block").addClass("article-detail");
            // $(".intro-block").addClass("article-detail");
        }

        if ($(".secondary-page").length > 0) {
            // $(".intro-block").removeClass("article-detail");
            // $(".intro-block .description-wrap article").removeClass('align-center');
            // $(".intro-block .description-wrap article").removeClass('align-left');
            // $(".intro-block .description-wrap article").removeClass('align-right');
            // $(".intro-block .description-wrap figure").removeClass('align-center');
            // $(".intro-block .description-wrap figure").removeClass('align-left');
            // $(".intro-block .description-wrap figure").removeClass('align-right');
            $(".intro-block p").removeAttr("style");
        }

        var length_centre = $(".intro-block.article-detail .description-wrap img.align-center").length;
        var length_left = $(".intro-block.article-detail .description-wrap img.align-left").length;
        var length_right = $(".intro-block.article-detail .description-wrap img.align-right").length;
        if (length_centre === 1) {
            $(".intro-block.article-detail .description-wrap img.align-center").parent().addClass("align-center");
        }
        if (length_right === 1) {
            $(".intro-block.article-detail .description-wrap img.align-right").parent().addClass("align-right");
        }
        if (length_left === 1) {
            $(".intro-block.article-detail .description-wrap img.align-left").parent().addClass("align-left");
        }

        if ($(".full-content article").length > 0) {
            $('.full-content .container').contents().wrapAll("<div class='description-wrap'></div>");
            setTimeout(function() {
                $(".full-content").addClass("article-detail");
            }, 200);
        }
        if ($(".full-content figure").length > 0) {
            $('.full-content .container').contents().wrapAll("<div class='description-wrap'></div>");
            setTimeout(function() {
                $(".full-content").addClass("article-detail");
            }, 200);
        }


        // $('.article-detail.news-wrap .content iframe').each(function() {
        //     var linkval = $(this).attr('src');
        //     var url = linkval;
        //     linkval = linkval.split('/')[5];
        //     if (linkval) {
        //         $(this).attr('src', "https://e.issuu.com/embed.html?d=" + linkval + "&pageLayout=singlePage&pageNumber=1&u=hooverinstitution");
        //     } 
        // });

        $('.article-detail.news-wrap .content img').each(function() {
            var pdf_length = $(this).attr("alt");

            if (pdf_length === "application-pdf.png") {
                $(this).parent().addClass('pdf-icon');
            }
        });

        if ($(".gallery-slider").length > 0) {
            $(".article-detail").addClass("min-margin-bottom");
        }

        setTimeout(function() {
            $(".article-detail.news-wrap.event-detail .content p").each(function() {
                var para_length = jQuery(this).find("img").length;
                if (para_length === 1) {
                    $(this).addClass("img-circle");
                    $(".article-detail.news-wrap.event-detail").addClass("small-font");
                }
            });
        }, 400);
        setTimeout(function() {
            $(".article-detail.news-wrap.research-detail .content p").each(function() {
                var para_length = jQuery(this).find("img").length;
                if (para_length === 1) {
                    $(this).addClass("img-circle");
                    $(".article-detail.news-wrap.research-detail").addClass("small-font");
                }
            });
        }, 400);
        setTimeout(function() {
            $(".article-detail.news-detail .content p").each(function() {
                var para_length = jQuery(this).find("img").length;
                if (para_length === 1) {
                    $(this).addClass("img-circle");
                    $(".article-detail.news-detail").addClass("small-font");
                }
            });
        }, 400);
        // setTimeout(function() {
        //     $(".article-detail.news-detail .content article").each(function() {
        //         var para_length = jQuery(this).find("img").length;
        //         if (para_length === 1) {
        //             $(this).addClass("img-circle");
        //             $(".article-detail.news-detail").addClass("small-font");
        //         }
        //     });
        // }, 400); 
        if ((".article-detail").length > 0) {
            $('.article-detail .detail-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: true,
                cssEase: 'linear',
            });
            $(".article-detail table").each(function() {
                $(this).wrapAll('<div class="overflow-x"></div>');
            });

        }

        $('.article-detail .sidebar .title').each(function() {
            if ($(this).text().trim() === "") {
                $(this).hide();
            }
        });

        $('.article-detail .sidebar .content-link p a').each(function() {
            if ($(this).text().trim() === "") {
                $('.article-detail .sidebar').find('.title').hide();
            }
        });

        // $('.article-detail .content p').find('[name="button"]').addClass('btn-red');
        $('.article-detail .content-description p').find('[name="button"]').addClass('btn-red-border');

        $(".article-detail .article-sidebar .content-description").each(function() {
            if ($(this).find("img").attr("src") == "") {
                $(this).find(".img-wrapper").hide();
            }
        });
   
        if ($(".article-detail").length > 0) {
            $('.article-detail').each(function() {
                var $article = $(this);
                
                $article.find('.content .transcript-wrap').each(function() {
                    var $wrap = $(this);
                    var $transcript = $wrap.find('.transcript');
                    var $toggleButton = $wrap.find('.show-script, .hidden');
            
                    if ($transcript.find('p').length > 0) {
                        $transcript.hide();
                    }
            
                    $toggleButton.on('click', function() {
                        $transcript.slideToggle(function() {
                            if ($transcript.is(':visible')) {
                                $toggleButton.text("Hide Transcript -");
                            } else {
                                $toggleButton.text("Show Transcript +");
                            }
                        });
                    });
                });
            });
        
            $(document).on('click', '.article-detail .content .show-script', function() {
                var $toggleButton = $(this);
                if ($toggleButton.text() === "Hide Transcript -") { 
                    var $wrap = $toggleButton.closest('.transcript-wrap');
                    var headerHeight = $wrap.offset().top - $("header").outerHeight() - 10;
                    $("html, body").animate({
                            scrollTop: headerHeight,
                        },
                        300,
                        "linear"
                    );
                }
            });
        }
    });
    
    var slider = $(".article-slider .row-wrap");
    slider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
    });
    $(window).on('load', function() {
        if ($(".intro-block .description-wrap article").length > 0) {
            $(".intro-block").addClass("article-detail");
        }
        $('.intro-block .description-wrap article img').each(function() {
            var height = $(this).height();
            $(this).parent().next("p").css("height", height + "px");
        });
        setTimeout(function() {
            $('.intro-block .description-wrap article img').each(function() {
                var height = $(this).height();
                $(this).parent().next("p").css("height", height + "px");
            });
        }, 500);
        if ($(".article-detail").length > 0) {

            //$(".article-detail").css({'opacity': '1'});

            $(".article-detail table").each(function() {
                $(this).wrapAll('<div class="overflow-x"></div>');
            });

        }
        $(".article-detail #disqus_recommendations").before(
            '<div id="cp"><h4>Join the Conversation</h4><a class="cp-btn" href="#">COMMENTS POLICY</a><div class="content-wrap"><h3>COMMENTS POLICY</h3><p>While the Hoover Institution welcomes comments from readers, we exercise the right to monitor the comments we receive. We will delete comments that include obscenities, swear-words and vulgarisms; ad hominem attacks; racist expression; rudeness or discourtesy; violations of copyright; or any other transgression of taste or civility that the editors deem unpublishable on a Hoover Institution Web site. The editors recommend that commenters use their real names when posting. If commenters post under a screen name, we reserve the right to delete the comment. We reserve the right, also, to close down comments on a particular essay if the editors believe we have reached "saturation" point.</p></div></div>'
        );

        function videoOverlay() {
            $(document).on("click", ".cp-btn", function(e) {
                e.preventDefault();
                var comment = $(this).parent().find(".content-wrap").clone();

                $(".img-video-overlay").find(".img-video-container").html(comment);

                $(".img-video-overlay").addClass("overlay-active comments");
            });
        }

        function closeVideoOverlay() {
            $(document).on("click", ".img-video-overlay.overlay-active", function(e) {
                if ($(e.target).is(".img-video-overlay")) {
                    $(".img-video-overlay").removeClass("overlay-active");
                }
            });
        }

        videoOverlay();
        closeVideoOverlay();
    });

    $(document).ready(function () {
      $('.article-detail .content a[href*="#"]').on('click', function (e) {
        if ($(this).attr('href').indexOf('#') !== -1) {
            var target = $(this).attr('href').split('#')[1];
            if (target) {
                var $targetElement = $('#' + target);
            
            if ($targetElement.length) {
                var offset = $("body").hasClass('toolbar-tray-open') ? 80 : 0;
                var $bannerWithDetail = $('.banner-with-detail');
                if ($bannerWithDetail.length && $bannerWithDetail.find('.header-icons').length) {
                    var navHeight = $bannerWithDetail.find('.header-icons').outerHeight();
                    offset += navHeight;
                }
    
                $('html, body').animate({
                    scrollTop: $targetElement.offset().top - offset
                }, 500, 'linear', function () {
                    window.location.hash = target;
                });
            }
            } else {
                e.preventDefault();
            }
        }
      });
    });
    
    $('.drupalview .news-slider ').unwrap().unwrap();
})(jQuery);